import { IGetPesquisaSatisfacaoByIdUseCase } from "../../../presentation/useCases/read/get_pesquisa_satisfacao_by_id_use_case";
import { PesquisaSatisfacaoDetalhes } from "../../models/pesquisa_satisfacao_detalhes";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetPesquisaSatisfacaoByIdUseCase
 */

export class GetPesquisaSatisfacaoByIdUseCase implements IGetPesquisaSatisfacaoByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async getPesquisaSatisfacaoById(
    idPesquisaSatisfacao: number | undefined,
  ): Promise<PesquisaSatisfacaoDetalhes> {
    if (idPesquisaSatisfacao === undefined) throw new Error('ID de pesquisa de satisfação é obrigatório!');
    const results = await this.repository.getPesquisaSatisfacaoById(idPesquisaSatisfacao);
    if (results === null) throw new Error('Pesquisa de satisfação não encontrada!');
    return results;
  }
}
